import Link from "next/link";
import { getGlobalData } from "utils/api";
import { getLocalizedPaths } from "utils/localize";
import Image from "next/image";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";
import useSearchWithBreadCrumbs from "@/components/brandRefresh/common/use-search-with-breadcrumbs";

const customerCareLinks = [
  {
    title: "Accessibility",
    link: "customer-care/accessibility",
  },
  {
    title: "Complaints",
    link: "customer-care/complaints",
  },
  {
    title: "Third party authorisation",
    link: "customer-care/third-party",
  },
  {
    title: "Financial Support",
    link: "customer-care/financial-support",
  },
];

const searchFilterCallback = (customerCareLinks = [], search = "") =>
  customerCareLinks.filter(link =>
    link.title.toLowerCase().includes(search.toLowerCase()),
  );

export default function CustomerCare({ metadata }) {
  const { renderSearchView, filteredValues: careLinks } =
    useSearchWithBreadCrumbs({
      defaultValues: customerCareLinks,
      searchFilterCallback,
      showAutoCompleteDropDown: false,
    });

  return (
    <RefreshHeader metadata={metadata}>
      <div className="text-sm md:text-base 4xl:text-xl">
        {renderSearchView()}
        <div className="flex flex-col gap-4">
          {careLinks.map(item => {
            return (
              <Link
                className="bg-onmoPurple-50 px-6 md:px-10 py-6 text-onmoPrimary rounded-xl text-base md:text-xl 4xl:text-2xl font-medium"
                key={item.title}
                href={item.link}
              >
                <p className="flex justify-between items-center">
                  <span>{item.title}</span>
                  <Image
                    src="/images/icons/chevron-right.svg"
                    alt="chevron-right-icon"
                    className=" h-6 w-6"
                    height="24"
                    width="24"
                  />
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </RefreshHeader>
  );
}

export async function getServerSideProps(context) {
  const { locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `Customer Care`,
  };

  return {
    props: {
      metadata,
      global: globalLocale.data,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}
